(function () {
    'use strict';

    angular
        .module('franchiser.components')
        .controller('UnitFormFranchiserController', UnitFormFranchiserController)

    /** @ngInject */
    function UnitFormFranchiserController($timeout, $state, $q, $stateParams, PersonService, HelperService, NotifyService, ClusterService, EconomicGroupService, UnitService, CityService, StateService, AuthenticationService, sweetAlert, SYSTEM_MODULES) {
        const vm = this;

        let allCities = [];

        vm.changeTab = tabId => {
            vm.selectedTab = tabId;
        }

        // Data
        vm.saveUnit = () => {
            if (!vm.selectedEconomicGroup) {
                HelperService.setErrorMessageForm('.economic-group');
                return;
            }

            if (!vm.selectedStatus) {
                HelperService.setErrorMessageForm('.status');
                return;
            }

            if (!vm.selectedType) {
                HelperService.setErrorMessageForm('.type');
                return;
            }

            if (vm.unitData.IsHybrid && (!vm.selectedAdditionalTypes || !vm.selectedAdditionalTypes.length)) {
                HelperService.setErrorMessageForm('.additional-type');
                return;
            }

            if (!vm.selectedState || vm.selectedState.Id == 0) {
                HelperService.setErrorMessageForm('.state');
                return;
            }

            if (!vm.selectedCity || vm.selectedCity.Id == 0) {
                HelperService.setErrorMessageForm('.city');
                return;
            }

            vm.unitData.Address.StateId = vm.selectedState.Id;
            vm.unitData.Address.CityId = vm.selectedCity.Id;

            HelperService.startLoading('.loading-holder');

            if (vm.unitData.Unit_Address && vm.unitData.Unit_Address.length)
                vm.unitData.Unit_Address[0].Address = vm.unitData.Address;
            else {
                vm.unitData.Unit_Address = [];
                vm.unitData.Unit_Address.push({
                    Address: vm.unitData.Address,
                    AddressTypeId: 1
                });
            }

            let unitDocuments = [];

            if (vm.unitData.Unit_Document && vm.unitData.Unit_Document.length) {
                unitDocuments = vm.unitData.Unit_Document.reduce((acc, cur) => {
                    if (cur.DocumentTypeId && cur.Document) {
                        acc.push({
                            DocumentTypeId: cur.DocumentTypeId,
                            Document: cur.Document
                        })
                    }

                    return acc;
                }, []);
            }

            let unitEmails = vm.unitData.Unit_Email.reduce((acc, cur) => {
                if (cur.EmailTypeId && cur.Email.Address) {
                    acc.push({
                        EmailTypeId: cur.EmailTypeId,
                        Email: {
                            Address: cur.Email.Address
                        }
                    })
                }

                return acc;
            }, []);

            let unitTelephones = vm.unitData.Unit_Phone.reduce((acc, cur) => {
                if (cur.PhoneTypeId && cur.Phone.Code && cur.Phone.Number) {
                    acc.push({
                        PhoneTypeId: cur.PhoneTypeId,
                        Phone: {
                            Code: cur.Phone.Code,
                            Number: cur.Phone.Number
                        }
                    })
                }

                return acc;
            }, []);

            let unitDataPost = {
                HeadUnitId: vm.unitData.HeadUnitId,
                Id: vm.unitData.Id,
                UniqueCode: vm.unitData.UniqueCode,
                ExternalCode: vm.unitData.ExternalCode,
                StatusId: vm.selectedStatus.Id,
                EconomicGroupId: vm.selectedEconomicGroup.Id,
                ClusterId: vm.selectedCluster ? vm.selectedCluster.Id : null,
                UnitTypeId: vm.selectedType.Id,
                FantasyName: vm.unitData.FantasyName,
                CorporateName: vm.unitData.CorporateName,
                Url: vm.unitData.Url,
                OpeningDate: vm.unitData.OpeningDateFormatted ? HelperService.getMomentDate(vm.unitData.OpeningDateFormatted).format('YYYY-MM-DD') : null,
                ConsultantPersonId: vm.selectedConsultant ? vm.selectedConsultant.Id : null,
                RegistrationDate: vm.unitData.RegistrationDate,
                UpdateDate: vm.unitData.UpdateDate,
                Unit_Address: vm.unitData.Unit_Address,
                Active: vm.unitData.Active,
                Delivery: vm.unitData.Delivery,
                Closed: false,
                Unit_Document: unitDocuments,
                Unit_Email: unitEmails,
                Unit_Phone: unitTelephones,
                KmServiceDistance: vm.unitData.KmServiceDistance,
                InOpeningProcess: vm.unitData.InOpeningProcess,
                UnitAdditionalType: getUnitAdditionalTypesPost(),
                PdvKey: vm.selectedPdvSystem ? vm.selectedPdvSystem.Key : null,
                // Vazio limpa; nulo diz ao SSO para manter o gravado -- e o que vai quando a lista nao carregou, para o
                // formulario nao apagar o sistema da loja sem o operador ter visto o campo.
                StoreSystemKey: vm.storeSystemsLoaded ? (vm.selectedStoreSystem ? vm.selectedStoreSystem.Key : '') : null
            };

            if (!unitDataPost.Id) {
                unitDataPost.Image = '';

                UnitService
                    .post(unitDataPost)
                    .then(success => successCallback(success, true), errorCallback);
            } else {
                UnitService
                    .put(unitDataPost)
                    .then(successCallback, errorCallback);
            }
        }

        vm.closeUnit = () => {
            sweetAlert.swal({
                title: 'Você tem certeza?',
                text: 'Essa loja não conseguirá mais acessar o sistema e seus dados não estarão mais disponíveis. Para que essa loja possa ser utilizada novamente é preciso realizar a reativação da mesma!',
                type: 'warning',
                confirmButtonText: 'Sim, tenho certeza',
                showCancelButton: true,
                cancelButtonText: 'Não, cancelar',
                allowOutsideClick: false,
                allowEscapeKey: false
            }).then(response => {
                if (response.value) {
                    HelperService.startLoading('.page-content');

                    UnitService
                        .delete(vm.unitData.Id)
                        .then(() => {
                            $state.go('app.franchiser-units');

                            NotifyService.success('Loja fechada com sucesso');
                            HelperService.stopLoading('.page-content');
                        }, error => {
                            HelperService.stopLoading('.page-content');
                            HelperService.errorCallback(error);
                        })
                }
            })
        }

        vm.getCities = preSelectedCityId => {
            delete vm.selectedCity;

            vm.cities = [];

            if (!vm.selectedState || !vm.selectedState.Id) {
                vm.cityPlaceholder = 'ESCOLHA O ESTADO';
                return $q.resolve([]);
            }

            vm.cityPlaceholder = 'AGUARDE...';

            return CityService
                .getByState(vm.selectedState.Id)
                .then(success => {
                    if (!success.length)
                        vm.cityPlaceholder = 'NENHUM RESULTADO';
                    else
                        vm.cityPlaceholder = 'ESCOLHA A CIDADE';

                    allCities = success;

                    if (preSelectedCityId)
                        vm.selectedCity = allCities.find(city => (city.Id == preSelectedCityId));
                }, error => {
                    HelperService.errorCallback(error);
                })
        }

        vm.searcCities = search => {
            if (!search) {
                vm.units = [];
                return;
            }

            vm.cities = allCities.filter(unit => filterCity(unit, search));
        }

        vm.changeUnitStatus = status => {
            vm.unitData.Active = status;
        }

        vm.changeUnitDelivery = isDelivery => {
            vm.unitData.Delivery = isDelivery;
        }

        vm.changeUnitHybrid = isHybrid => {
            vm.unitData.IsHybrid = isHybrid;
            vm.selectedAdditionalTypes = isHybrid ? (vm.selectedAdditionalTypes || []) : [];
        }

        vm.changeUnitOpeningProcess = isInProcess => {
            vm.unitData.InOpeningProcess = isInProcess;
        }

        vm.onSelectUnitType = () => {
            if (vm.selectedType && vm.selectedAdditionalTypes && vm.selectedAdditionalTypes.length)
                vm.selectedAdditionalTypes = vm.selectedAdditionalTypes.filter(type => type.Id != vm.selectedType.Id);
        }

        vm.refreshUnit = () => {
            if (!vm.unitData.ExternalCode) {
                NotifyService.error('Unidade sem código externo cadastrado.')
                return;
            }

            sweetAlert.swal({
                title: 'Você tem certeza?',
                text: 'Você está prestes a importar os dados dessa loja. Essa ação é irreversível!',
                type: 'warning',
                confirmButtonText: 'Sim, tenho certeza',
                showCancelButton: true,
                cancelButtonText: 'Não, cancelar',
                allowOutsideClick: false,
                allowEscapeKey: false
            }).then(response => {
                if (response.value) {
                    HelperService.startLoading('.loading-holder');

                    UnitService
                        .refreshUnitFromIdeologica(vm.unitData.ExternalCode)
                        .then(() => {
                            $state.reload();

                            NotifyService.success('Loja atualizada com sucesso!');
                            HelperService.stopLoading('.loading-holder');
                        }, error => {
                            HelperService.stopLoading('.loading-holder');
                            HelperService.errorCallback(error);
                        })
                }
            })
        }

        init();

        // Unit data
        function successCallback(success, isPost) {
            if (isPost) {
                formatDates(success);

                vm.unitData = success;
                vm.unitData.Address = success.Unit_Address[0];
                vm.unitForm.reset();

                sweetAlert.swal({
                    title: 'Loja cadastrada com sucesso!',
                    html: `Código externo da loja: <strong>${vm.unitData.ExternalCode}</strong>`,
                    type: 'success',
                    confirmButtonText: 'Editar loja',
                    showCancelButton: true,
                    cancelButtonText: 'Fechar',
                    allowOutsideClick: false,
                    allowEscapeKey: false
                }).then(response => {
                    if (response.value) {
                        $timeout(() => {
                            $state.go('app.franchiser-units-edit', {
                                unitId: vm.unitData.Id
                            }, {
                                notify: false
                            });
                        })
                    }
                })
            } else
                HelperService.successCallback('update');

            HelperService.stopLoading('.loading-holder');
        }

        function errorCallback(error) {
            HelperService.stopLoading('.loading-holder');
            HelperService.errorCallback(error);
        }

        function filterCity(city, search) {
            if (city.Name == null)
                city.Name = '';

            if (city.Name.toLowerCase().includes(search.toLowerCase()))
                return city;
        }

        function formatDates(unitData) {
            if (unitData.OpeningDate)
                unitData.OpeningDateFormatted = moment(unitData.OpeningDate).format('DD/MM/YYYY HH:mm:ss');
            else
                unitData.OpeningDateFormatted = '-';

            if (unitData.RegistrationDate)
                unitData.RegistrationDateFormatted = moment(unitData.RegistrationDate).format('DD/MM/YYYY HH:mm:ss');
            else
                unitData.RegistrationDateFormatted = '-';

            if (unitData.UpdateDate)
                unitData.UpdateDateFormatted = moment(unitData.UpdateDate).format('DD/MM/YYYY HH:mm:ss');
            else
                unitData.UpdateDateFormatted = '-';
        }

        function getUnit() {
            const unitId = $stateParams.unitId;

            if (!unitId) {
                vm.showExtraData = true;
                HelperService.stopLoading('.loading-holder');
                return;
            }

            UnitService
                .get(unitId)
                .then(success => {
                    formatDates(success);

                    vm.unitData = success;

                    vm.showExtraData = true;

                    if (vm.unitData.ClusterId)
                        vm.selectedCluster = vm.clusters.find(cluster => (cluster.Id == vm.unitData.ClusterId));

                    if (vm.unitData.EconomicGroupId)
                        vm.selectedEconomicGroup = vm.economicGroups.find(group => (group.Id == vm.unitData.EconomicGroupId));

                    if (vm.unitData.StatusId)
                        vm.selectedStatus = vm.status.find(status => (status.Id == vm.unitData.StatusId));

                    if (vm.unitData.ConsultantPersonId)
                        vm.selectedConsultant = vm.consultants.find(consultant => (consultant.Id == vm.unitData.ConsultantPersonId));

                    if (vm.unitData.UnitTypeId)
                        vm.selectedType = vm.types.find(type => (type.Id == vm.unitData.UnitTypeId));

                    setSelectedPdvSystem();

                    setSelectedStoreSystem();

                    setSelectedAdditionalType();

                    if (vm.unitData.Unit_Address.length) {
                        vm.unitData.Address = success.Unit_Address[0].Address;
                        vm.selectedState = vm.states.find(state => (state.Id == vm.unitData.Address.City.StateId));

                        vm.getCities(vm.unitData.Address.City.Id);
                    }

                    vm.unitData.EcommerceSubsellerId = vm.unitData.EcommerceSubsellerId || 'N/D';
                    vm.unitData.EcommerceGetNetStatus = vm.unitData.EcommerceGetNetStatus || 'N/D';

                    if (vm.unitData.EcommerceAcceptanceDate != null)
                        vm.unitData.EcommerceAcceptanceDate = moment(vm.unitData.EcommerceAcceptanceDate).format('DD/MM/YYYY HH:mm:ss')
                    else
                        vm.unitData.EcommerceAcceptanceDate = 'N/D';

                    vm.unitGatewayStatus = vm.unitData.UnitBraspagStatus[0] || {};

                    if (vm.unitGatewayStatus.RegistrationDate != null)
                        vm.unitGatewayStatus.RegistrationDate = moment(vm.unitGatewayStatus.RegistrationDate).format('DD/MM/YYYY HH:mm:ss')
                    else
                        vm.unitGatewayStatus.RegistrationDate = 'N/D';

                    if (vm.unitGatewayStatus.UpdateDate != null)
                        vm.unitGatewayStatus.UpdateDate = moment(vm.unitGatewayStatus.UpdateDate).format('DD/MM/YYYY HH:mm:ss')
                    else
                        vm.unitGatewayStatus.UpdateDate = 'N/D';

                    HelperService.stopLoading('.loading-holder');
                }, error => {
                    HelperService.stopLoading('.loading-holder');
                    $state.go('app.franchiser-units');
                    HelperService.errorCallback(error);
                })
        }

        function getClusters() {
            return ClusterService
                .getAll()
                .then(success => {
                    vm.clusters = success;
                }, error => {
                    HelperService.errorCallback(error);
                })
        }

        function getEconomicGroups() {
            return EconomicGroupService
                .getAll()
                .then(success => {
                    vm.economicGroups = success;
                }, error => {
                    HelperService.errorCallback(error);
                })
        }

        function getStatus() {
            return UnitService
                .getStatus()
                .then(success => {
                    vm.status = success;
                }, error => {
                    HelperService.errorCallback(error);
                })
        }

        function getStates() {
            return StateService
                .getAll()
                .then(success => {
                    vm.states = success.filter(state => (state.Id != 0));
                }, error => {
                    HelperService.errorCallback(error);
                })
        }

        function getConsultants() {
            return PersonService
                .getConsultants()
                .then(success => {
                    vm.consultants = success;
                }, error => {
                    HelperService.errorCallback(error);
                })
        }

        function getTypes() {
            return UnitService
                .getTypes()
                .then(success => {
                    vm.types = success;
                }, error => {
                    HelperService.errorCallback(error);
                })
        }

        function getPdvSystems() {
            return UnitService
                .getPdvSystems()
                .then(success => {
                    vm.pdvSystems = success || [];
                    vm.pdvSystemOptions = vm.pdvSystems.slice();
                }, error => {
                    HelperService.errorCallback(error);
                })
        }

        function setSelectedPdvSystem() {
            vm.pdvSystemOptions = (vm.pdvSystems || []).slice();
            vm.selectedPdvSystem = null;

            if (!vm.unitData.PdvKey)
                return;

            vm.selectedPdvSystem = vm.pdvSystemOptions.find(pdv => (pdv.Key == vm.unitData.PdvKey));

            if (vm.selectedPdvSystem)
                return;

            // A loja aponta para um PDV que foi desativado. Ele nao vem em /pdv-systems, e sem essa
            // opcao o select ficaria vazio -- salvar o formulario apagaria o vinculo em silencio.
            // Mantem a opcao so para esta loja, marcada como inativa, para o operador ver o que esta
            // gravado e trocar de propósito, nao por acidente.
            vm.selectedPdvSystem = {
                Key: vm.unitData.PdvKey,
                Description: vm.unitData.PdvKey + ' (inativo)',
                Active: false
            };

            vm.pdvSystemOptions.push(vm.selectedPdvSystem);
        }

        // Sistema da loja (ML System, MaxPan), devolvido ao app cliente na lista de lojas. Campo opcional: se a lista nao
        // carregar (banco sem o script), o formulario segue funcionando e nao mexe no valor gravado.
        function getStoreSystems() {
            return UnitService
                .getStoreSystems()
                .then(success => {
                    vm.storeSystems = success || [];
                    vm.storeSystemOptions = vm.storeSystems.slice();
                    vm.storeSystemsLoaded = vm.storeSystems.length > 0;
                }, () => {
                    vm.storeSystems = [];
                    vm.storeSystemOptions = [];
                    vm.storeSystemsLoaded = false;
                })
        }

        function setSelectedStoreSystem() {
            vm.storeSystemOptions = (vm.storeSystems || []).slice();
            vm.selectedStoreSystem = null;

            if (!vm.unitData.StoreSystemKey)
                return;

            vm.selectedStoreSystem = vm.storeSystemOptions.find(system => (system.Key == vm.unitData.StoreSystemKey));

            if (vm.selectedStoreSystem)
                return;

            // Mesmo caso do PDV: sistema desativado nao vem na lista, e sem a opcao o select ficaria vazio e salvar
            // apagaria o vinculo em silencio.
            vm.selectedStoreSystem = {
                Key: vm.unitData.StoreSystemKey,
                Description: vm.unitData.StoreSystemKey + ' (inativo)',
                Active: false
            };

            vm.storeSystemOptions.push(vm.selectedStoreSystem);
        }

        function initVars() {
            const loggedUserData = AuthenticationService.getSelectedData();

            vm.showExtraData = false;
            vm.unitData = {
                Unit_Document: [],
                Unit_Email: [],
                Unit_Phone: [],
                Active: true,
                // Raio padrão da rede (10 km). O campo é obrigatório e vinha vazio: na abertura digitava-se 0 ou 1 para
                // salvar, e a loja aberta ficava fora da busca (corrigidas 11 lojas em 03/10/2026).
                KmServiceDistance: 10
            };

            vm.selectedAdditionalTypes = [];
            vm.pdvSystems = vm.pdvSystems || [];
            vm.pdvSystemOptions = vm.pdvSystems.slice();
            vm.selectedPdvSystem = null;
            vm.storeSystems = vm.storeSystems || [];
            vm.storeSystemOptions = vm.storeSystems.slice();
            vm.selectedStoreSystem = null;

            vm.canUserHandlePerson = AuthenticationService.getUnitDataByAccessLevelAndModuleId(loggedUserData.AccessLevelId, SYSTEM_MODULES.FRANCHISER_PEOPLE).length > 0;
            vm.canUserHandleJuridical = loggedUserData.AccessLevelId == 1 || loggedUserData.AccessLevelId == 6;
            vm.selectedTab = 1;
            vm.cityPlaceholder = 'ESCOLHA UM ESTADO';
        }

        function getUnitAdditionalTypesPost() {
            if (!vm.unitData.IsHybrid || !vm.selectedAdditionalTypes || !vm.selectedAdditionalTypes.length)
                return [];

            return vm.selectedAdditionalTypes.map(type => ({
                UnitId: vm.unitData.Id || 0,
                UnitTypeId: type.Id,
                Active: true
            }));
        }

        function setSelectedAdditionalType() {
            vm.unitData.IsHybrid = !!vm.unitData.IsHybrid;
            vm.selectedAdditionalTypes = [];

            if (!vm.unitData.UnitAdditionalType || !vm.unitData.UnitAdditionalType.length)
                return;

            // Carrega TODOS os tipos adicionais ativos (o backend suporta um ou mais).
            // Manter todos aqui evita que salvar a loja desative os que a UI nao exibiu.
            vm.selectedAdditionalTypes = vm.unitData.UnitAdditionalType
                .filter(type => type.Active)
                .map(type => vm.types.find(t => t.Id == type.UnitTypeId))
                .filter(type => type);

            vm.unitData.IsHybrid = vm.selectedAdditionalTypes.length > 0;
        }

        vm.getAvailableAdditionalTypes = search => {
            let types = vm.types || [];

            if (vm.selectedType)
                types = types.filter(type => type.Id != vm.selectedType.Id);

            if (vm.selectedAdditionalTypes && vm.selectedAdditionalTypes.length)
                types = types.filter(type => !vm.selectedAdditionalTypes.some(selected => selected.Id == type.Id));

            if (!search)
                return types;

            return types.filter(type => type.Description && type.Description.toLowerCase().includes(search.toLowerCase()));
        }

        function init() {
            initVars();

            HelperService.startLoading('.loading-holder');

            $q.all([getStates(), getClusters(), getEconomicGroups(), getStatus(), getConsultants(), getTypes(), getPdvSystems(), getStoreSystems()])
                .then(() => {
                    getUnit();
                })
        }
    }
}());
